export const searchSuccessStoryInitialState = {
  filters: {
    name: "",
    clinic: "",
    clinicNames: "",
    doctor: "",
    doctorNames: "",
  },
  currentPage: 1,
  totalPages: 1,
  allSuccessStoryList: [],
  isSuccessStoryListLoading: false,
};

export const searchSuccessStoryReducer = (state, action) => {
  switch (action.type) {
    case "SET_SUCCESS_STORY_FILTERS":
      return {
        ...state,
        filters: { ...state.filters, ...action.payload },
        currentPage: 1, // reset to page 1 when filters change
      };
    case "SET_SUCCESS_STORY_PAGE":
      return { ...state, currentPage: action.payload };
    case "SET_SUCCESS_STORY_DATA":
      return {
        ...state,
        allSuccessStoryList: action.payload.data,
        totalPages: action.payload.totalPages,
        isSuccessStoryListLoading: false,
      };
    case "SET_SUCCESS_STORY_LOADING":
      return { ...state, isSuccessStoryListLoading: action.payload };
    case "RESET_SUCCESS_STORY_FILTERS":
      return {
        ...searchSuccessStoryInitialState,
      };
    default:
      return state;
  }
};
